module.exports = __webpack_public_path__ + "img/1409952532.91b68836.jpg";